const clientType = {
  Clinic: 1,
  NonClinical: 2,
}

export default clientType;